import type { Schema } from '../../../Entities/Schema.entity';
import { createSchema } from '../../../Utils/CreateSchema';

export const registrationAttemptExitSchema: Schema = {
  ...createSchema({
    version: '1-0-2',
    description:
      "Tracks when a user attempts to exit the registration before it is complete. Note: This event is based on the browser's beforeunload/onunload behavior and will be fired while the browser's default exit confirmation modal is shown. After this event fires, the user may cancel the unload and continue with the registration.",
    name: 'registration_attempt_exit',
    properties: {
      path: {
        type: 'string',
        description: 'The URL path at the time of attempted exit',
      },
    },
  }),
};
